/* 224 header logo intro (Represent-style). On every full page load the header does not show the finished logo straight away:
   the infinity mark appears and traces one lap, then lifts away while the 224 logo wipes in from the left. After that the
   normal logo stays put (no scroll animation). Once the intro is done the markup is cleaned up and the animation can never
   replay when the theme re-renders the header (e.g. after add to cart).
   Mark images come from the layout (window.r224MarkDark / window.r224MarkLight). */
(function () {
  if (window.__r224logo) return;
  window.__r224logo = true;

  var INTRO_MS = 2700;
  var done = false;
  var root = document.documentElement;

  function ensure() {
    if (done) return;
    var dark = window.r224MarkDark, light = window.r224MarkLight;
    if (!dark) return;
    document.querySelectorAll('.pageheader .logo__link').forEach(function (link) {
      if (link.querySelector('.r224-mark')) return;
      var m = document.createElement('span');
      m.className = 'r224-mark';
      m.setAttribute('aria-hidden', 'true');
      m.innerHTML = '<img class="r224-mark__dark" src="' + dark + '" alt="" decoding="async">' +
        (light ? '<img class="r224-mark__light" src="' + light + '" alt="" decoding="async">' : '');
      link.appendChild(m);
    });
  }

  function finish() {
    if (done) return;
    done = true;
    root.classList.add('r224-intro-done');
    document.querySelectorAll('.r224-mark').forEach(function (m) { m.remove(); });
    if (observer) observer.disconnect();
  }

  var observer = null;
  function start() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { finish(); return; }
    ensure();
    setTimeout(finish, INTRO_MS);
    var timer = null;
    observer = new MutationObserver(function () {
      if (timer || done) return;
      timer = setTimeout(function () { timer = null; ensure(); }, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
